import React from 'react';
import { Navigate } from 'react-router';
import { useFlowium } from '../client/FlowiumContext';
import LoadingPage from '../components/LoadingPage';

const AuthRoute: React.FC = () => {
    const { isAuthenticated, isInitializing } = useFlowium();
    if (isInitializing) {
        return <LoadingPage />;
    }
    return isAuthenticated ? <Navigate to="/browser" replace /> : <Navigate to="/login" replace />;
};

export default AuthRoute;
